<template>
  <v-autocomplete
    v-model="item"
    :label="label"
    :loading="loading"
    :items="items"
    :search-input.sync="search"
    clearable
    hide-no-data
    :hide-details="hideDetails"
    item-text="seriove_cislo"
    item-id="id"
    :filter="filter"
    return-object
    :rules="rules"
    @blur="change"
  >
    <template
      slot="selection"
      slot-scope="{ item, selected }"
    >
      <span v-text="item.seriove_cislo"></span>
    </template>
    <template
      slot="item"
      slot-scope="{ item, tile }"
    >
      <v-list-tile-content>
        <v-list-tile-title>{{ item.seriove_cislo }}</v-list-tile-title>
      </v-list-tile-content>
    </template>
  </v-autocomplete>
</template>
<script>
export default {
  data: function () {
    return {
      loading: false,
      items: [],
      search: "",
      counter: 0,
      timeout: null,
      item: null,
      muteWatchOnce: false
    }
  },
  props: {
    hideDetails: Boolean,
    outline: Boolean,
    rules: Array,
    value: String,
    all: Boolean,
    disabled: Boolean,
    label: String,
    produkt: Number,
    nahradniProdukty: Boolean,
    prodane: Boolean,
    everyChange: Boolean,
    clearOnSelect: Boolean
  },
  watch: {
    search (val) {
      val && val !== this.item && this.queryClients(val)
    },
    item (v) {
      if (this.muteWatchOnce) {
        this.muteWatchOnce = false;
        return;
      }
      this.$emit("changed", v);
      this.$emit("input", v != null ? v.seriove_cislo : null);
      if (this.$props.clearOnSelect) {
        this.muteWatchOnce = true;
        this.clear();
      }
    }
  },
  mounted: function() {
    if (this.value != null)
      this.loadBasic();
  },
  methods: {
    filter: function(e) {
      return true;
    },
    queryClients: function(v) {
      this.counter++;
      if (this.timeout != null)
        clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        this.loading = true
        window.api.post("sklady/seriova-cisla/search", {
          s: v,
          echo: this.counter,
          produkt: this.produkt,
          nahradni: this.nahradniProdukty,
          prodane: this.prodane
        }).then(function($r) {
          if ($r.echo != this.counter) return;
          this.items = $r.data;
          this.loading = false;
        }.bind(this)).catch(function(err) {
          console.log(err);
        }.bind(this));
      }.bind(this), 300)
    },
    clear () {
      this.item = null;
      this.items = [];
      this.search = "";
    },
    change (e) {
      if (this.everyChange && this.item == null) {
        this.$nextTick(() => {
          this.items.push({
            id: null,
            seriove_cislo: this.search
          });
          this.item = this.items[this.items.length - 1];
        });
      }
    }
  },
  components: {

  }
}
</script>
<style scoped>
.v-select__selection-text {
  max-width: 100px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/SerioveCisloSearch.vue